import { createGlobalStyle } from 'styled-components';

/**
 * AMI's react-select rules, moved out of custom.css and rewritten from react-select 3's generated class
 * names (css-<hash>-control ...) to the react-select__* names the ReactSelect wrapper's classNamePrefix
 * emits in every version. Values, !important flags and source order are ported 1:1 rather than mapped to
 * tokens, so existing selects look exactly as before. The focused placeholder gets position: relative
 * because version 5 lays it out with grid instead of absolute positioning, and its search icon is
 * positioned against it. Mount once (library/GlobalStyles.js): every mounted copy injects the rules again.
 */
export const ReactSelectGlobalStyle = createGlobalStyle({
    '.disabled-select .react-select__control--is-disabled': {
        pointerEvents: 'visible',
        cursor: 'not-allowed !important',
        backgroundColor: '#e9ecef !important',
    },
    '.form-group-blk .custom-select-box.disabled-select .react-select__control': {
        backgroundColor: '#e9ecef !important',
    },
    '.form-icon-group .custom-select-box .react-select__control': {
        minHeight: '42px !important',
        border: 'none !important',
        background: 'transparent !important',
    },
    '.custom-select-box .react-select__control--is-focused, .custom-select-box .react-select__control--is-disabled': {
        minHeight: '42px !important',
        border: 'none !important',
        background: 'transparent !important',
        boxShadow: 'none !important',
    },
    '.custom-select-box .react-select__placeholder': {
        color: '#495057',
    },
    '.custom-select-box .react-select__control--is-focused .react-select__placeholder': {
        position: 'relative',
        paddingLeft: '20px',
    },
    '.custom-select-box .react-select__control--is-focused .react-select__placeholder:before': {
        content: "'\\f002'",
        fontFamily: "'Font Awesome 7 Pro'",
        top: '2px',
        position: 'absolute',
        left: '0',
        color: '#4a7dbf',
    },
    '.custom-select-box .react-select__menu': {
        zIndex: '99',
    },
    '.profile-box-2 .custom-select-box .react-select__control': {
        height: '42px !important',
        border: 'none !important',
        background: 'transparent !important',
    },
    '.form-group-blk .custom-select-box .react-select__control': {
        minHeight: '42px !important',
        border: 'none !important',
        background: 'transparent !important',
        height: 'auto !important',
    },
    '.assesment-dropdown.programme .react-select__option': {
        maxWidth: '100%',
    },
    '.assesment-dropdown .react-select__multi-value': {
        maxWidth: '90px',
    },
    '.assesment-dropdown .react-select__option': {
        fontSize: '13px !important',
        borderBottom: '1px solid rgba(0, 0, 0, 0.125) !important',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '300px',
        overflow: 'hidden',
    },
    '.assesment-dropdown .react-select__option--is-focused': {
        fontSize: '13px !important',
        background: '#eff0f2 !important',
        borderBottom: 'transparent !important',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        maxWidth: '300px',
        overflow: 'hidden',
    },
    '.assesment-dropdown .react-select__control--is-focused': {
        boxShadow: 'none !important',
        borderColor: 'hsl(0, 0%, 80%) !important',
    },
    '.assesment-dropdown .react-select__control--is-focused:hover': {
        borderColor: 'hsl(0, 0%, 80%) !important',
    },
    '.assesment-dropdown .react-select__control:not(.react-select__control--is-focused) .react-select__dropdown-indicator, .assesment-dropdown .react-select__control:not(.react-select__control--is-focused) .react-select__clear-indicator': {
        display: 'none !important',
    },
    '.assesment-dropdown .react-select__multi-value__remove:hover': {
        backgroundColor: '#ef8700fc !important',
        color: '#ffffff !important',
    },
    '.assesment-dropdown .react-select__placeholder': {
        fontSize: '13px !important',
    },
    '.form-group-blk > .is-multi .react-select__control': {
        height: 'auto !important',
    },
    '.color-drop .react-select__menu > div': {
        padding: '8px 0',
        display: 'flex',
        flexFlow: 'row wrap',
        width: '100%',
    },
    '.color-drop .react-select__menu div': {
        background: 'none',
        display: 'inline-flex',
        borderBottom: '1px solid #eff0f2',
    },
    '.color-drop .react-select__menu div:last-child': {
        borderBottom: '0px',
    },
    '.color-drop .react-select__menu div span': {
        padding: '3px 5px',
        borderRadius: '2px',
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: '10px',
        textTransform: 'uppercase',
        fontWeight: '600',
        lineHeight: '1.2',
    },
    '.color-drop .react-select__menu > div span.red': {
        backgroundColor: '#ffaaaa',
        color: '#ff0000 !important',
    },
    '.color-drop .react-select__menu > div span.skyblue': {
        backgroundColor: '#e0ffff !important',
        color: '#40e0d0 !important',
    },
    '.color-drop .react-select__menu > div span.green': {
        backgroundColor: '#d5ffd9 !important',
        color: '#00c915 !important',
    },
    '.color-drop .react-select__menu > div span.blue': {
        backgroundColor: '#e0edff !important',
        color: '#1899d2 !important',
    },
    '.color-drop .react-select__menu > div span.yellowshade': {
        background: '#e7e8d7 !important',
        color: '#abb072 !important',
    },
    '.color-drop .react-select__menu > div > div:hover': {
        background: '#f3f6f9',
    },
    '.react-select__multi-value__label .custom-filter-selected': {
        borderRadius: '2px',
        color: 'hsl(0, 0%, 20%)',
        fontSize: '85%',
        overflow: 'hidden',
        padding: '3px',
        paddingLeft: '6px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
    },
    '.react-select__multi-value .cat': {
        display: 'block',
    },
    '.custom-table-div .rdt_TableRow .react-select__menu': {
        maxHeight: '108px',
        overflow: 'auto',
    },
    '.custom-table-div .rdt_TableRow:last-child .react-select__menu': {
        bottom: '100%',
        top: 'auto',
    },
    '.custom-table-div .rdt_TableRow:nth-last-child(2) .react-select__menu': {
        bottom: '100%',
        top: 'auto',
    },
    '.submisson-table-item1.custom-table-div .rdt_TableRow:last-child .react-select__menu': {
        bottom: '-10px',
        top: 'auto',
    },
    '.react-select__control--is-disabled .react-select__indicator-separator': {
        minWidth: '0 !important',
    },
    '.react-select__multi-value__label span': {
        background: 'transparent !important',
        color: '#333 !important',
    },
});
